import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/search';

export const FOR_CREDIT_SEARCH_FILTER_VARIANTS = {
  CONTROL: 'control',
  A: 'a',
  B: 'b',
};

export const getShouldShowForCreditFilter = () =>
  GrowthDiscoveryExperiments.get('showCreditEligibilityFilterOnSearch') !== FOR_CREDIT_SEARCH_FILTER_VARIANTS.CONTROL;

export const getForCreditFilterLabelText = () => {
  const activeVariant = GrowthDiscoveryExperiments.get('showCreditEligibilityFilterOnSearch');
  let text;

  if (activeVariant === FOR_CREDIT_SEARCH_FILTER_VARIANTS.A) text = _t('Degree Credit Eligible');
  if (activeVariant === FOR_CREDIT_SEARCH_FILTER_VARIANTS.B) text = _t('Credit Eligible');

  return text;
};

export default {
  FOR_CREDIT_SEARCH_FILTER_VARIANTS,
  getForCreditFilterLabelText,
  getShouldShowForCreditFilter,
};
